import { render, staticRenderFns } from "./Classifiers.vue?vue&type=template&id=56034dde&"
import script from "./Classifiers.vue?vue&type=script&lang=js&"
export * from "./Classifiers.vue?vue&type=script&lang=js&"
import style0 from "./Classifiers.vue?vue&type=style&index=0&id=56034dde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QInput from 'quasar/src/components/input/QInput.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBanner,QBtn,QIcon,QSpinnerIos,QSelect,QTooltip,QSeparator,QDialog,QCard,QBar,QSpace,QCardSection,QCardActions,QInput});qInstall(component, 'directives', {ClosePopup});
